import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import EconomicActivityForm from './EconomicActivityForm';

const EconomicActivityActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const EconomicActivityEdit = (props: any) => {
  return (
    <Edit actions={<EconomicActivityActions {...props} />} {...props}>
      <EconomicActivityForm />
    </Edit>
  );
};

export default EconomicActivityEdit;
